import React from 'react';
import {
  Box,
  Container,
  Flex,
  VStack,
  Text,
  Heading
} from '@chakra-ui/react';

const Header = () => {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      className="bg-gradient-to-r from-stone-50 to-warmGray-100 shadow-md"
      bg="rgba(255, 255, 255, 0.95)"
      backdropFilter="blur(8px)"
    >
      <Container maxW="6xl" mx="auto">
        <Box className="px-8 py-4 md:px-4 md:py-3">
          {/* Logo Section */}
          <VStack spacing={0} align="center">
            
            {/* Brand Row */}
            <Flex align="center" gap={1}>
              {/* Logo Icon */}
              <Box
                w={{ base: "72px", md: "90px" }}
                h={{ base: "72px", md: "90px" }}
                display="flex"
                alignItems="center"
                justifyContent="center"
                role="img"
                aria-label="StyloQ App Logo"
              >
                <img
                  src="/images/logo/logo.png"
                  alt="StyloQ Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                  }}
                />
              </Box>

              {/* App Name */}
              <Heading
                as="h1"
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="semibold"
                className="text-stone-800 tracking-tight"
                m={0}
              >
                StyloQ
              </Heading>
            </Flex>

            {/* Tagline */}
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              fontWeight="normal"
              className="text-stone-600 tracking-wide"
              textAlign="center"
              m={0}
              mt={-2.5}
            >
              One search. Every store. Perfect style.
            </Text>

            {/* Decorative Bottom Accent Line */}
            <Box
              position="relative"
              width="100%"
              height="1px"
            >
              <Box
                position="absolute"
                bottom={0}
                left="50%"
                transform="translateX(-50%)"
                w={24}
                h="1px"
                className="bg-gradient-to-r from-transparent via-amber-400 to-transparent"
              />
            </Box>

          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;